import { createFileRoute, redirect } from '@tanstack/react-router'

// Bảng giá Online đã chuyển sang nhóm Bán lẻ (/retail/online-prices). Giữ đường
// dẫn cũ làm redirect cho bookmark; SHOP_ENABLED tắt thì đích báo không tồn tại.
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/products/online-prices',
)({
    beforeLoad: () => {
        throw redirect({ to: '/retail/online-prices' })
    },
})
